export const cardType = token => {
  switch (token?.slice(1, 3)) {
    case '34':
      return 'American Express';
    case '44':
      return 'Visa';
    case '54':
      return 'MasterCard';
    case '64':
      return 'Discover';
    default:
      return 'Other';
  }
};
